module.exports = __webpack_public_path__ + "static/media/green_line_process_32.9f006193.svg";